import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import axios from 'axios';
import baseUrl from '../../helper/api';

const initialState = {
    isLoading:false,
    status:null,
    data: '',
    error:null
}

export const resetPassword = createAsyncThunk(
    'auth/resetPassword',
    async (data, {rejectWithValue}) => {
        try{
            const response = await axios.post(`${baseUrl}/Account/resetPassword`, data)
            return response?.data
        } catch (err) {
            console.log(err)
            return rejectWithValue(err.response.data.title)
        }
        
    }
)

const resetPasswordSlice = createSlice({
    name:"resetPassword",
    initialState,
    reducers:{},
    extraReducers:{
        [resetPassword.pending]: (state, action) => {
            state.status='pending';
            state.isLoading=true;
        },
        [resetPassword.fulfilled]: (state, action) => {
            state.status='success';
            state.isLoading=false;
            state.data = action.payload;
            // localStorage.setItem('user', JSON.stringify(action.payload))
        },
        [resetPassword.rejected]: (state, action) => {
            state.status='failed';
            state.isLoading=false;
            state.error = action.error
        }
    }
})

export default resetPasswordSlice.reducer;